export default __webpack_public_path__ + "static/1-c2092de5b46b8a84faa12d8c302e3eee.png";